import { Tabs } from "antd";
import { parseAsStringEnum, useQueryState } from "nuqs";
import React from "react";

import { AdvisorConversationsTab } from "./AdvisorConversationsTab";
import { AdvisorOffersTab } from "./AdvisorOffersTab";
import { AdvisorSettingsTab } from "./AdvisorSettingsTab";

// TRE-1613 — "Doradca klientek" admin module: conversations (read-only preview +
// agent-initiated chats), client_offer CRUD and settings (skills / knowledge base).

const advisorTabKeys = ["conversations", "offers", "settings"] as const;
type AdvisorTabKey = (typeof advisorTabKeys)[number];

export const ClientAdvisor = (): React.ReactElement => {
  // `tab` belongs to the parent Automation tabs — the advisor keeps its own key.
  const [activeTab, setActiveTab] = useQueryState(
    "advisorTab",
    parseAsStringEnum<AdvisorTabKey>([...advisorTabKeys]).withDefault("conversations"),
  );

  return (
    <Tabs
      activeKey={activeTab}
      onChange={(key) => void setActiveTab(key as AdvisorTabKey)}
      destroyInactiveTabPane
      items={[
        {
          key: "conversations",
          label: "Rozmowy",
          children: <AdvisorConversationsTab />,
        },
        {
          key: "offers",
          label: "Oferty",
          children: <AdvisorOffersTab />,
        },
        {
          key: "settings",
          label: "Ustawienia",
          children: <AdvisorSettingsTab />,
        },
      ]}
    />
  );
};

export default ClientAdvisor;
